import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { AppLayout } from './components/layout/AppLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Validations } from './pages/Validations';
import { Commandes } from './pages/Commandes';
import { Laveries } from './pages/Laveries';
import { Livreurs } from './pages/Livreurs';
import { Clients } from './pages/Clients';
import { Promos } from './pages/Promos';
import { Parametres } from './pages/Parametres';
import { Services } from './pages/Services';
import { Support }           from './pages/Support';
import { ChangePassword }    from './pages/ChangePassword';
import { Courses }           from './pages/Courses';
import { Reglements }        from './pages/Reglements';
import { ServiceCategories } from './pages/ServiceCategories';
import { FinanceOverview }   from './pages/FinanceOverview';

// ── Route publique : redirige si déjà connecté ────────────────────────────────
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user?.role === 'admin') {
    // Si le mdp doit être changé, aller vers /change-password
    if (user.password_reset_required) return <Navigate to="/change-password" replace />;
    return <Navigate to="/" replace />;
  }
  return children;
};

// ── Route qui force le changement de mdp si le flag est actif ────────────────
const PasswordResetRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  // Si pas de flag → pas besoin de changer le mdp → accueil
  if (!user.password_reset_required) return <Navigate to="/" replace />;
  return children;
};

// ── Route protégée : admin connecté + mdp ok ─────────────────────────────────
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/login" replace />;
  // v2.2 : si mdp temporaire non changé → forcer /change-password
  if (user.password_reset_required) return <Navigate to="/change-password" replace />;
  return children;
};

const AppRoutes = () => (
  <Routes>
    {/* Public */}
    <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />

    {/* Changement de mot de passe obligatoire (v2.2) */}
    <Route path="/change-password" element={<PasswordResetRoute><ChangePassword /></PasswordResetRoute>} />

    {/* Protected admin routes */}
    <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
      <Route path="/"            element={<Dashboard />} />
      <Route path="/validations" element={<Validations />} />
      <Route path="/commandes"   element={<Commandes />} />
      <Route path="/courses"            element={<Courses />} />
      <Route path="/reglements"         element={<Reglements />} />
      <Route path="/finance"            element={<FinanceOverview />} />
      <Route path="/service-categories" element={<ServiceCategories />} />
      <Route path="/laveries"    element={<Laveries />} />
      <Route path="/livreurs"    element={<Livreurs />} />
      <Route path="/clients"     element={<Clients />} />
      <Route path="/promos"      element={<Promos />} />
      <Route path="/services"    element={<Services />} />
      <Route path="/support"     element={<Support />} />
      <Route path="/parametres"  element={<Parametres />} />
    </Route>

    {/* Fallback */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
